import i18n from "@cirrus/legacy/app-common/alt/framework/i18n.js"
import { propEq, not, any } from "ramda"

export const makeHiddenReadableText = (text, translate = true) => {
  return `
    <span class="rs_message"><!-- ${translate ? i18n(text) : text} --></span>
    <br style="display: none" class="rs_pause" />
  `
}

export const init = (id, region) => {
  const rsScript = document.createElement("script")

  rsScript.type = "text/javascript"
  rsScript.src = `//f1-${region}.readspeaker.com/script/${id}/webReader/webReader.js?pids=wr&notools=1`
  rsScript.id = "rs_req_Init"

  $("head").append(rsScript)
}

export const getIsLanguageDisabled = (current, languages) =>
  not(any(propEq("cirrusLangKey", current), languages))
